module.exports = __webpack_public_path__ + "static/media/domains.800bb60c.svg";